import { useMemo } from 'react'

import type { ClassData, LibraryData } from '@/core/types/library.type'
import {
  analyzeLibraryGraftability,
  filterGraftabilityIssuesForClass,
  type LibraryGraftabilityReport,
} from '@/core/utils/graftability'

export function useGraftability(libraryData?: LibraryData, classData?: ClassData): LibraryGraftabilityReport | null {
  return useMemo(() => {
    if (!libraryData) return null

    const report = analyzeLibraryGraftability(libraryData)
    if (!classData) return report

    return filterGraftabilityIssuesForClass(report, classData)
  }, [libraryData, classData])
}
